"use client";
import { useTranslation } from "@/i18n/client";
import React from "react";
import FaqAccordion from "@/components/FaqAccordion";
import Text from "@/components/Text";
import classes from "./index.module.css";
import { Process, ProcessSpecification, Segment } from "@/types/contract";
import { Product } from "@/types/enumerations";
import { RecontractingVariant } from "@/types/recontractingRequest";
import { getListItems } from "../../helpers";
import { Trans } from "react-i18next";
import { ProcessReasonType } from "@/types/processReason";
import { Stack } from "@mantine/core";
import { useIsNewCustomerLink } from "@/hooks/useIsNewCustomerLink";
import { useIsContractRequest } from "@/hooks/useIsContractRequest";

interface ProcessDescriptionProps {
  process: Process;
  selfService: boolean;
  product?: Product | null;
  processSpecification?: ProcessSpecification | null;
  recontractingVariant?: RecontractingVariant | null;
  processReason?: ProcessReasonType | null;
  phase?: string | null;
  segment?: Segment | null;
}
const ProcessDescription = ({
  process,
  selfService,
  product,
  processSpecification,
  recontractingVariant,
  processReason,
  phase,
  segment,
}: ProcessDescriptionProps) => {
  const { t } = useTranslation("welcome");
  const isContractRequest = useIsContractRequest();
  const isNewCustomerLink = useIsNewCustomerLink();
  const isPSRequest = process === Process.PS && isContractRequest && phase !== "draft";

  const items = getListItems(
    selfService,
    product ?? null,
    processSpecification ?? null,
    process,
    recontractingVariant ?? null,
    processReason ?? null,
    phase ?? null,
    segment ?? null,
    isContractRequest,
    isNewCustomerLink,
    t
  );
  return (
    <FaqAccordion
      header={t("processDescriptionHeader")}
      body={
        <Stack gap={24}>
          <ul className={classes.ul}>
            {Object.values(items).map((item, i) => (
              <li key={i}>
                <Text variant="reading_list">
                  <Trans>{item}</Trans>
                </Text>
              </li>
            ))}
          </ul>
          {isPSRequest && !isNewCustomerLink && (
            <Text variant="reading_list" color="neutral.7">
              {t("processDescriptionPSRequest")}
            </Text>
          )}
        </Stack>
      }
    />
  );
};

export default ProcessDescription;
